import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home, 
  Clock, 
  Sparkles, 
  Compass, 
  User,
  Sun
} from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

// Kundli/Sun symbol component
const KundliIcon = ({ className }) => (
  <Sun className={className} />
);

const ShubhBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const navItems = [
    { 
      path: '/dashboard', 
      icon: Home, 
      label: language === 'hi' ? 'होम' : 'Home',
      testId: 'nav-home'
    },
    { 
      path: '/timeline', 
      icon: Clock, 
      label: language === 'hi' ? 'समयरेखा' : 'Timeline',
      testId: 'nav-timeline'
    },
    { 
      path: '/janam-kundli', 
      icon: KundliIcon, 
      label: language === 'hi' ? 'कुंडली' : 'Kundli',
      isSpecial: true,
      testId: 'nav-kundli'
    },
    { 
      path: '/rashifal', 
      icon: Sparkles, 
      label: language === 'hi' ? 'राशिफल' : 'Rashifal',
      testId: 'nav-rashifal'
    },
    { 
      path: '/profiles', 
      icon: User, 
      label: language === 'hi' ? 'आप' : 'You',
      testId: 'nav-you'
    },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname === '/';
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav 
      className="shubh-bottom-nav"
      data-testid="shubh-bottom-navigation"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="shubh-bottom-nav-inner">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          if (item.isSpecial) {
            // Special Kundli button in center
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`shubh-nav-item kundli-special ${active ? 'active' : ''}`}
                data-testid={item.testId}
                aria-label={item.label}
                aria-current={active ? 'page' : undefined}
              >
                <motion.div 
                  className="shubh-nav-icon-wrapper"
                  whileTap={{ scale: 0.92 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                >
                  <Icon className="shubh-nav-icon" />
                </motion.div>
                <span className="shubh-nav-label" style={{ marginTop: '-4px' }}>
                  {item.label}
                </span>
              </button>
            );
          }
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`shubh-nav-item ${active ? 'active' : ''}`}
              data-testid={item.testId}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
            >
              {active && (
                <motion.div
                  layoutId="shubhActiveTab"
                  className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] rounded-b-full"
                  style={{
                    background: 'linear-gradient(90deg, #C84B32, #F5B942)',
                  }}
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
              <motion.div
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <Icon className="shubh-nav-icon" />
              </motion.div>
              <span className="shubh-nav-label">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default ShubhBottomNav;
